import {User} from "@/interfaces/user";
import {INewProjectMetadata} from "@/interfaces/report";
import {UnitSystem} from "@/interfaces/units";

export const createNewProject = function (user: User): INewProjectMetadata {

  // if (user !== null){
  return {
    id: null,
    name: '',
    user: user ? user.id! : -1,
    created: new Date(Date.now()).toISOString(),
    modified: new Date(Date.now()).toISOString(),
    // created: null,
    // modified: null,
    visible: true,
    isComputedFromLegacy: false,
    r23ReportId: null,
    displayUnits: UnitSystem.Imperial,
    state: null,
    description: null,
    owner: null
  }
  // } else {
  // return null
  // }
};
